import { FormGroup, FormBuilder } from '@angular/forms';
import { FormMake745Build } from './forms-build/form-make745-build';

export class FormMake745 extends FormMake745Build {
    public CreateForm(formBuilder: FormBuilder): FormGroup {
        const formulario: FormGroup = formBuilder.group({
            id: [0, []],
            centro_ensaque: ['', []],
            data_ensaque: ['', []],
            numero_campo: ['', []],
            safra: ['', []],
            hibrido_rnc: ['', []],
            geracao: ['', []],
            lote_origem: ['', []],
            peneira: ['', []],
            lote_saida: ['', []],
            status_lote: ['', []],
            peso_sessenta_mil_sementes_impressao_kg: ['', []],
            peso_total_lote_kg: ['', []],
            estimativa_pa: ['', []],
            linha_ensaque: ['', []],
            turno_ensaque: ['', []],
            responsavel_pelo_ensaque: ['', []],
            responsavel_pela_conferencia_lote: ['', []],
            data_conferencia_fisica: ['', []],
            data_hora_apontamento: ['', []],
            status_processo: ['', []],
            observacao: ['', []],
            created_by: ['', []],
            origem_negocio: ['', []],
            offline: true,
        });
        return formulario;
    }
}
